import React from 'react';
import { useTranslation } from 'react-i18next';
import { prettyNumber } from '../../../../utils/helpers';
import { KapitalbankButton } from '../KapitalbankButton';
import { PriceSectionContainer, SectionArea, SectionPrice } from './styled';

interface PriceSectionProps {
  price?: number | null;
  area?: number | null;
  priceCurrency: string;
  areaCurrency?: string | null;
  isApartmentForSale: boolean;
  isAuthor: boolean;
  isKapitalbankApplicable: boolean;
  onCreditCalcClick: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PriceSection: React.FC<PriceSectionProps> = ({
  price,
  area,
  priceCurrency,
  areaCurrency,
  isApartmentForSale,
  isKapitalbankApplicable,
  isAuthor,
  onCreditCalcClick
}) => {
  const { t } = useTranslation();

  const handleOpenCreditCalcModalView = () => {
    onCreditCalcClick(true);
  };

  const prettyPrice = prettyNumber(price);
  const pricePerSqm = (
    Math.round((price || 0) / (area || 0) / 10) * 10
  ).toFixed();
  const prettyPricePerSqm = prettyNumber(pricePerSqm);

  return (
    <PriceSectionContainer data-cy="price-section">
      <SectionPrice
        tag="h2_new"
        data-cy="price-section__i"
        $withBigMargin={isApartmentForSale}
        $withMargin={isApartmentForSale || isKapitalbankApplicable}
      >
        {prettyPrice} {priceCurrency}
      </SectionPrice>
      {isApartmentForSale && (
        <SectionArea
          tag="body_3"
          data-cy="price-section__i"
          $isKapitalbankApplicable={isKapitalbankApplicable}
        >
          {t('pages.current_item.price_per_sqm', {
            price: prettyPricePerSqm,
            area_currency: areaCurrency
          })}
        </SectionArea>
      )}
      {isKapitalbankApplicable && !isAuthor && (
        <KapitalbankButton onClick={handleOpenCreditCalcModalView} />
      )}
    </PriceSectionContainer>
  );
};
